// TransportOffersView.js

import transportOffersController from "@/services/transportOffersService";
import Swal from "sweetalert2";

export default {
  name: "TransportOffersView",

  data() {
    return {
      loading: false,
      transportOffers: [],
      total: 0,
      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filters: {
        search: "",
        status: "",
      },
      searchTimeout: null,
    };
  },

  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.perPage));
    },
    visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 2;
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      if (current + delta < total - 1) range.push("...");

      range.unshift(1);
      if (total > 1) range.push(total);

      return range;
    },
  },

  methods: {
    goToAdd() {
      this.$router.push("/transport/transport-offers/add");
    },

    goToEdit(id) {
      this.$router.push(`/transport/transport-offers/edit/${id}`);
    },

    goToDetail(id) {
      this.$router.push(`/transport/transport-offers/detail/${id}`);
    },

    onSearchInput() {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        this.page = 1;
        this.getData();
      }, 400);
    },

    onFilterChange() {
      this.page = 1;
      this.getData();
    },

    changePerPage() {
      this.page = 1;
      this.getData();
    },

    goToPage(newPage) {
      if (newPage < 1 || newPage > this.totalPages) return;

      this.page = newPage;
      this.getData();
    },

    async getData() {
      try {
        this.loading = true;

        const res = await transportOffersController.getAll({
          page: this.page,
          limit: this.perPage,
          search: this.filters.search,
          status: this.filters.status === "" ? null : this.filters.status,
          sortBy: "id",
          sortDesc: "true",
        });
        this.transportOffers = res.data || [];
        this.total = res.total || 0;
        if (this.page > this.totalPages) {
          this.page = this.totalPages;
          await this.getData();
        }
      } catch (error) {
        console.error(error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed load data",
        });
      } finally {
        this.loading = false;
      }
    },

    getExpiredBadgeClass(status) {
      if (status === "EXPIRED") {
        return "badge-danger";
      }

      if (status === "SOON_EXPIRED") {
        return "badge-warning";
      }

      return "badge-success";
    },
  },

  mounted() {
    this.getData();
  },
};
